import { CSSProperties, Component, ReactNode, createElement } from "react";

import { TranslationConsumer } from "@/app/providers";

import { Language } from "@/model/Language/Language";

export interface ITranslateProps {
	String?: string;
	className?: string;
}

export interface IHtmlTagTranslateProps extends ITranslateProps {
	id?: string;
	htmlFor?: string;
	HTMLTag?:
		| "h1"
		| "h2"
		| "h3"
		| "h4"
		| "h5"
		| "h6"
		| "label"
		| "li"
		| "p"
		| "span";
	style?: CSSProperties;
	children?: ReactNode;
}

export function GetLanguageValueAsString(
	ctx: Language | null,
	key: string,
	value: string,
) {
	if (ctx !== null) {
		const string = ctx.Strings.filter((k) => k.Key === key);
		return string.length > 0 ? string[0].Value : value;
	}

	return value;
}

export function GetLanguageValue(
	ctx: Language | null,
	key: string,
	value: string | ReactNode,
): { value: string | ReactNode; missingTranslationKey: string } {
	let message = "";
	if (ctx !== null) {
		const string = ctx.Strings.filter((k) => k.Key === key);
		value = string.length > 0 ? string[0].Value : value;
		if (string.length === 0) {
			message = key;
		}
	}

	return { value, missingTranslationKey: message };
}

export class Translate extends Component<IHtmlTagTranslateProps> {
	renderTranslation(ctx: Language | null) {
		let val = this.props.children;
		let message = "";
		const translationKey =
			this.props.String ??
			(typeof this.props.children === "string" ? this.props.children : "");
		if (ctx !== null) {
			const string = ctx.Strings.filter((k) => k.Key === translationKey);
			val = string.length > 0 ? string[0].Value : val;
			if (string.length === 0) {
				message = translationKey;
			}
		}

		return createElement(
			this.props.HTMLTag ? this.props.HTMLTag : "span",
			{
				id: this.props.id,
				className: this.props.className,
				htmlFor: this.props.htmlFor,
				title: message,
				style: this.props.style,
			},
			val,
		);
	}

	render() {
		return (
			<TranslationConsumer>
				{(ctx: Language | null) => this.renderTranslation(ctx)}
			</TranslationConsumer>
		);
	}
}
